<div class="container-fluid bg-white py-1">
  <div class="row">
    <div class="col-4">
      <h3>Demurrage Details for Invoice: {{ demurrageDetails?.invoiceNum || '' }}</h3>
    </div>
    <div class="col-3">
      <mat-form-field class="w-100 action-type" appearance="outline">
        <mat-label>Please Select Action</mat-label>
        <mat-select [(ngModel)]="selectedOption" disableOptionCentering>
          <mat-option value="ALL">Download All Bill Types</mat-option>
          <mat-option *ngFor="let type of demurrageDetails?.demurrageTypes" [value]="type.value">Download Bill
            Type {{ type.value + ' - ' + type.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-3">
      <button class="mt-1" mat-flat-button aria-label="Go" (click)="downloadExcel.emit(selectedOption)" color="accent">
        Go
      </button>
    </div>
    <div class="col-2 text-right">
      <button mat-stroked-button aria-label="Return To List" (click)="navigateBack()">
        Return To List
      </button>
    </div>
  </div>
  <div class="row d-flex justify-content-center">
    <div class="col-2">
      <div class="d-flex justify-content-between">
        <strong>Bill Date:</strong>
        <b>{{ demurrageDetails?.billDate | date:'MM/dd/yyyy' }}</b>
      </div>
      <div class="d-flex justify-content-between">
        <strong>Customer Number:</strong>
        <b>{{ demurrageDetails?.customerNumber }}</b>
      </div>
    </div>
    <div class="ml-5 col-2">
      <div class="d-flex justify-content-between">
        <strong>Station Number:</strong>
        <b>{{ demurrageDetails?.stationNumber }}</b>
      </div>
      <div class="d-flex justify-content-between">
        <strong>WayBill Number:</strong>
        <b>{{ demurrageDetails?.waybillNumber }}</b>
      </div>
      <div class="d-flex justify-content-between">
        <strong>Bill To:</strong>
        <b>{{ demurrageDetails?.billTo }}</b>
      </div>
    </div>
    <div class="col-3">
      <div class="d-flex justify-content-around">
        <strong>Address:</strong>
        <b [innerHTML]="demurrageDetails?.address"></b>
      </div>
    </div>
  </div>
  <div class="row my-3 d-flex justify-content-center">
    <div class="col-5">
      <ng-container *ngFor="let type of demurrageDetails?.demurrageTypes">
        <div class="d-flex justify-content-between">
          <strong>{{ type.name | titlecase }}</strong>
          <strong>{{ type.amount | currency }}</strong>
        </div>
      </ng-container>
      <div class="h-auto border-top">
        <div class="d-flex justify-content-between">
          <strong>Total Monthly Charge</strong>
          <strong>{{ demurrageDetails?.totalAmount | currency }}</strong>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="p-2">
  <table mat-table [dataSource]="categories" class="mat-elevation-z1 w-100">
    <ng-container matColumnDef="inOut">
      <th mat-header-cell *matHeaderCellDef class="text-center font-weight-bold">In/Out</th>
      <td mat-cell *matCellDef="let element" class="text-center font-weight-bold">{{ element.inOut }}</td>
    </ng-container>
    <ng-container matColumnDef="carsReleased">
      <th mat-header-cell *matHeaderCellDef class="text-center font-weight-bold">No. Cars Released</th>
      <td mat-cell *matCellDef="let element" class="text-center font-weight-bold">{{ element.carsReleased }}</td>
    </ng-container>
    <ng-container matColumnDef="creditDays">
      <th mat-header-cell *matHeaderCellDef class="text-center font-weight-bold">Credit Days</th>
      <td mat-cell *matCellDef="let element" class="text-center font-weight-bold">{{ element.creditDays }}</td>
    </ng-container>
    <ng-container matColumnDef="serviceCredits">
      <th mat-header-cell *matHeaderCellDef class="text-center font-weight-bold">Service Credits</th>
      <td mat-cell *matCellDef="let element" class="text-center font-weight-bold">{{ element.serviceCredits }}</td>
    </ng-container>
    <ng-container matColumnDef="carDays">
      <th mat-header-cell *matHeaderCellDef class="text-center font-weight-bold">Car Days</th>
      <td mat-cell *matCellDef="let element" class="text-center font-weight-bold">{{ element.carDays }}</td>
    </ng-container>
    <ng-container matColumnDef="chargeableDays">
      <th mat-header-cell *matHeaderCellDef class="text-center font-weight-bold">Chargeable Days</th>
      <td mat-cell *matCellDef="let element" class="text-center font-weight-bold">{{ element.chargeableDays }}</td>
    </ng-container>
    <ng-container matColumnDef="dailyCarRate">
      <th mat-header-cell *matHeaderCellDef class="text-right font-weight-bold">Daily Rate</th>
      <td mat-cell *matCellDef="let element" class="text-right font-weight-bold">{{ element.dailyCarRate | currency }}</td>
    </ng-container>
    <ng-container matColumnDef="amountDue">
      <th mat-header-cell *matHeaderCellDef class="text-right font-weight-bold">Amount Due</th>
      <td mat-cell *matCellDef="let element" class="text-right font-weight-bold">{{ element.amountDue | currency }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>

<mat-tab-group (selectedIndexChange)="selectedIndexChange($event)" class="ns-mat-tab-group h-100">
  <mat-tab *ngFor="let type of demurrageDetails?.demurrageTypes" [label]="type.name">
    <ng-template matTabContent>
      <ns-grid [loading]="loadingCarDetails"
               [columns]="columns"
               name="eBill_demurrage_details"
               [fileName]="'Demurrage Details for Invoice - ' + demurrageDetails?.invoiceNum || ''"
               (refresh)="loadCarDetails.emit(selectedDemurrage)"
               [data]="carDetails">
      </ns-grid>
    </ng-template>
  </mat-tab>
</mat-tab-group>
